import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks/core';
import { motion } from 'framer-motion';

import type { MenuLink } from '../../types';
import { ctaVariant } from '../menuAnimations';

interface MenuCTAProps {
  ctaLink?: MenuLink;
  ctaTitle?: string;
  animate: 'visible' | 'hidden';
}

export const MenuCTA: React.FC<MenuCTAProps> = ({ ctaLink, ctaTitle, animate }) => {
  if (!ctaLink?.name || !ctaLink?.href) return null;

  return (
    <Box
      as={motion.div}
      variants={ctaVariant}
      animate={animate}
      gridColumn="1"
      gridRow="3"
      pt={[7, null, 9]}
      w="100%"
    >
      <Link
        href={ctaLink.href}
        aria-label=""
        analyticsName={`cosmos-landing-page-v2-menu-cta-link-${ctaLink.name}`}
        backgroundColor="blue50"
        borderRadius="semiRounded"
        color="warmgrey950"
        display="block"
        fontWeight="medium"
        p="16px"
        _hover={{
          color: 'brandBlue600',
        }}
      >
        {ctaTitle && (
          <Text as="span" display="block" size="90" fontWeight="inherit">
            {ctaTitle}
          </Text>
        )}
        <Text as="span" color="inherit" display="block" size="110" fontWeight="inherit">
          {ctaLink.name}
        </Text>
      </Link>
    </Box>
  );
};
